module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/zh-hant/6-b0d0a2b144b03c19d27165c1a85d48c7.jpg";